import { render } from "./EditBlogPostDialog.vue?vue&type=template&id=ca235b6a"
import script from "./EditBlogPostDialog.vue?vue&type=script&lang=js"
export * from "./EditBlogPostDialog.vue?vue&type=script&lang=js"

import "./EditBlogPostDialog.vue?vue&type=style&index=0&id=ca235b6a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__